import React from "react"
import { css, keyframes } from "@emotion/css"

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
})

const spinnerStyle = css({
  display: "inline-block",
  width: "32px",
  height: "32px",
  border: "4px solid #e2e7e7",
  borderTopColor: "#ff9900",
  borderRadius: "50%",
  animation: `${spin} 0.9s linear infinite`,
})

const containerStyle = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  padding: "48px 16px",
})

interface SpinnerProps {
  label?: string
}

const Spinner: React.FC<SpinnerProps> = ({ label }) => (
  <div className={containerStyle} role="status" aria-live="polite">
    <span className={spinnerStyle} aria-hidden="true" />
    {label && <span>{label}</span>}
  </div>
)

export default Spinner
